import { captureAnalytics } from '../actions/preload';

// "Ordering Provider" and "Ordering Provider Group" are template markers, not EMA
// staff or groups. Only automatic tasking resolves them, from the provider the AI
// extracts from the document. A manual task has no such step, so sending either
// marker makes EMA reject the task. Manual flows drop them and make the user pick
// a real assignee. Keep in step with EmaTaskTemplate::ORDERING_PROVIDER_ASSIGNEES.
const AUTOMATIC_ASSIGNEE_MARKER_TYPES = new Map([
  ['Ordering Provider', 'ordering_provider'],
  ['Ordering Provider Group', 'ordering_provider_group'],
]);

const providerName = (provider) => (typeof provider === 'string' ? provider : provider?.name);

// The provider list for a non-fax record is the template editor's list, which
// includes both markers. Accepts names or { name } objects.
export const withoutAssigneeMarkers = (providers) => (
  (providers || []).filter((provider) => !AUTOMATIC_ASSIGNEE_MARKER_TYPES.has(providerName(provider)))
);

// The template's real assignees, for prefilling a manual task. Records when a
// marker was dropped, since the user then has to choose an assignee by hand.
export const manualTaskAssignees = (assignTo, { workflow, modalVariant }) => {
  const assignees = [];
  const clearedMarkerTypes = [];
  (assignTo || []).forEach((assignee) => {
    const markerType = AUTOMATIC_ASSIGNEE_MARKER_TYPES.get(assignee);
    if (markerType) {
      clearedMarkerTypes.push(markerType);
    } else {
      assignees.push(assignee);
    }
  });
  if (clearedMarkerTypes.length > 0) {
    captureAnalytics('manual_task_template_assignee_marker_cleared', {
      assignee_marker_types: clearedMarkerTypes,
      ...(workflow ? { workflow } : {}),
      modal_variant: modalVariant,
    });
  }
  return assignees;
};
